<template>
    <div id="suppliers-page">
        <LandingBanner/>
        <LoanCatalog/>
        <HowItWorks/>
        <Requirements/>
        <OwnSuccessStories :projects="successList">
            <template v-slot:title>
                Descubre qué han logrado <br> otras <span class="bold">empresas</span>.
            </template>
        </OwnSuccessStories>
        <ContactBanner/>
    </div>
</template>
    
<script>
import sal from 'sal.js';
import LandingBanner from '../../components/landing-components/suppliers-components/LandingBanner.vue';
import LoanCatalog from '../../components/landing-components/suppliers-components/LoansCatalog.vue';
import HowItWorks from '../../components/landing-components/suppliers-components/HowItWorks.vue';
import Requirements from '../../components/landing-components/suppliers-components/Requirements.vue';
import OwnSuccessStories from '@components/landing-components/for-business-components/OwnSuccessStories.vue';
import ContactBanner from '@components/landing-components/suppliers-components/ContactBanner.vue'
export default {
    name: "ImpactPage",
    components: {
        LandingBanner,
        LoanCatalog,
        HowItWorks,
        Requirements,
        OwnSuccessStories,
        ContactBanner
    },
    async mounted() {
        sal();
    },
    data() {
    return {
      successList: [
        {
          alias: "Alvah Energy",
          photo: "alvah-energy.jpg",
          item_list: [
            { title: "Fuente de emisión:", value: "Energía" },
            { title: "Línea de acción:", value: "Integración solar" },
            { title: "Beneficio:", value: "1320KW instalados/año" },
            { title: "Monto:", value: "$2,500,000.00" },
            { title: "Estado:", value: "Nuevo León" },
            { title: "Inversionistas:", value: "1191" },
          ]
        },
        {
          alias: "Universidad de Xalapa",
          photo: "univ-xalapa.jpeg",
          item_list: [
            { title: "Fuente de emisión:", value: "Energía" },
            { title: "Línea de acción:", value: "Solar fotovoltáico" },
            { title: "Beneficio:", value: "247 m2 instalados" },
            { title: "Monto:", value: "$1,490,024.00" },
            { title: "Estado:", value: "Veracruz" },
            { title: "Ahorros estimados:", value: "$284,896.71 MXN/año" },
            { title: "Huella de carbono:", value: "45.32 tonCO2/año" },
            { title: "Inversionistas:", value: "971" },
          ]
        },
        {
          alias: "Fit Crew",
          photo: "fit-crew.jpeg",
          item_list: [
            { title: "Fuente de emisión:", value: "Energía" },
            { title: "Línea de acción:", value: "Solar térmico" },
            { title: "Beneficio:", value: "247 m2 instalados" },
            { title: "Monto:", value: "$1,490,024.00" },
            { title: "Estado:", value: "CDMX" },
            { title: "Ahorros estimados:", value: "$600,240.00 MXN/año" },
            { title: "Huella de carbono:", value: "73.67 tonCO2/año" },
            { title: "Inversionistas:", value: "1298" },
          ]
        },
      ]
    }
  }
}
</script>
    
<style scoped></style>